const sanitizeInput = (input) => {
    return typeof input === 'string' ?  input.replace(/<([^>]+)>/g, ' $1 ') : input;    
}


const sanitizeObject = (data) => {
    if (Array.isArray(data)) {
        return data.map(sanitizeObject); // Recursively sanitize arrays
    } else if (data && typeof data === 'object') {
        // Recursively sanitize objects
        const sanitizedObj = {};
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                sanitizedObj[key] = sanitizeObject(data[key]);
            }
        }
        return sanitizedObj;
    } else if (typeof data === 'string') {
        return sanitizeInput(data); // Sanitize strings
    } else {
        return data; // Return other types as is
    }
}

export { sanitizeInput , sanitizeObject };